export default __webpack_public_path__ + "resources/icons/n221-b1fb.png";